// @flow
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { theme } from 'styles/Constants';

const Wrapper = styled.label`
  display: flex;
`;
const StyledIconCheck = styled(FontAwesomeIcon)`
  width: 100% !important;
  height: 100%;
  padding: 3px;
`;
const Input = styled.input.attrs({
  type: 'checkbox'
})`
  display: none;
`;
const Box = styled.div`
  display: inline-block;
  width: 18px;
  height: 18px;
  color: #ffffff;
  border-radius: 3px;
  ${({ checked, disabled }) => {
    if (checked) {
      return '';
    }

    return !disabled
      ? `border: solid 2px ${theme.primaryColor}`
      : 'border: solid 2px #ececec';
  }};
  background-color: ${({ checked, disabled }) => {
    if (checked && !disabled) {
      return theme.primaryColor;
    }
    if (checked && disabled) {
      return '#ececec';
    }
    return 'white';
  }};
`;
const Content = styled.div``;

type PropsType = {
  value: any,
  onChange: (value: boolean) => void,
  checked: boolean,
  children?: any,
  disabled?: boolean
};

const Checkbox = ({
  value = '',
  onChange = () => {},
  checked = false,
  children,
  disabled = false
}: PropsType) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleChange = ({ target }: Event) => {
    setIsChecked(prevState => !prevState.isChecked);
    onChange(target.checked);
  };

  return (
    <Wrapper>
      <Input checked={isChecked} onChange={handleChange} disabled={disabled} />
      <Box checked={isChecked} disabled={disabled}>
        {isChecked && <StyledIconCheck icon="check" />}
      </Box>
      <Content>{children}</Content>
    </Wrapper>
  );
};

export default Checkbox;
